module.exports = __webpack_public_path__ + "img/h-talk.bf343fb1.png";